export default class Timer {
    constructor() {
        this.startTime = (new Date()).getTime();

        this.start = this.start.bind(this);
        this.check = this.check.bind(this);
        this.stop = this.stop.bind(this);
    }

    start() {
        this.startTime = (new Date()).getTime();

    }

    check(mark) {
        let time = (new Date()).getTime() - this.startTime;
    }

    stop() {
        let time = (new Date()).getTime() - this.startTime;

        this.startTime = (new Date()).getTime();
    }
}